import { render, staticRenderFns } from "./SpinalAssessmentCheck.vue?vue&type=template&id=c8390c00&scoped=true&"
import script from "./SpinalAssessmentCheck.vue?vue&type=script&lang=js&"
export * from "./SpinalAssessmentCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8390c00",
  null
  
)

export default component.exports